(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunara-barra-anuncios"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(raiz) {
      if (raiz.dataset.luListo) return;
      raiz.dataset.luListo = '1';
      raiz.querySelectorAll('[data-lu-autoenvio]').forEach(function (selector) {
        selector.addEventListener('change', function () {
          selector.form.submit();
        });
      });
      var mensajes = raiz.querySelectorAll('.lu-anuncios__mensaje');
      if (mensajes.length < 2 || raiz.dataset.auto !== 'true') return;
      var actual = 0;
      var pausa = false;
      raiz.addEventListener('mouseenter', function () { pausa = true; });
      raiz.addEventListener('mouseleave', function () { pausa = false; });
      var temporizador = setInterval(function () {
        if (!raiz.isConnected) { clearInterval(temporizador); return; }
        if (pausa) return;
        mensajes[actual].classList.remove('lu-anuncios__mensaje--activo');
        actual = (actual + 1) % mensajes.length;
        mensajes[actual].classList.add('lu-anuncios__mensaje--activo');
      }, parseInt(raiz.dataset.velocidad, 10) || 5000);
      raiz.addEventListener('shopify:block:select', function (evento) {
        var destino = evento.target.closest('.lu-anuncios__mensaje');
        if (!destino) return;
        mensajes.forEach(function (m) { m.classList.remove('lu-anuncios__mensaje--activo'); });
        destino.classList.add('lu-anuncios__mensaje--activo');
        actual = parseInt(destino.dataset.indice, 10) || 0;
        pausa = true;
      });
    }
    function todos() {
      document.querySelectorAll('[data-lu-anuncios]').forEach(iniciar);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', todos);
    } else {
      todos();
    }
    document.addEventListener('shopify:section:load', todos);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunara-cabecera"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(raiz) {
      if (raiz.dataset.luListo) return;
      raiz.dataset.luListo = '1';
      var cajon = raiz.querySelector('[data-lu-cajon]');
      var botonAbrir = raiz.querySelector('[data-lu-abrir-cajon]');
      function abrir() {
        if (!cajon) return;
        cajon.classList.add('lu-cabecera__cajon--abierto');
        cajon.setAttribute('aria-hidden', 'false');
        if (botonAbrir) botonAbrir.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
        var cerrar = cajon.querySelector('button[data-lu-cerrar-cajon]');
        if (cerrar) cerrar.focus();
      }
      function cerrar() {
        if (!cajon) return;
        cajon.classList.remove('lu-cabecera__cajon--abierto');
        cajon.setAttribute('aria-hidden', 'true');
        if (botonAbrir) botonAbrir.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
      }
      if (botonAbrir) botonAbrir.addEventListener('click', abrir);
      raiz.querySelectorAll('[data-lu-cerrar-cajon]').forEach(function (el) {
        el.addEventListener('click', cerrar);
      });
      document.addEventListener('keydown', function (evento) {
        if (evento.key === 'Escape' && cajon && cajon.classList.contains('lu-cabecera__cajon--abierto')) cerrar();
      });
      var botonBuscar = raiz.querySelector('[data-lu-abrir-buscador]');
      var buscadorMovil = raiz.querySelector('.lu-cabecera__buscador-movil');
      if (botonBuscar && buscadorMovil) {
        botonBuscar.addEventListener('click', function () {
          var abierto = !buscadorMovil.hasAttribute('hidden');
          if (abierto) {
            buscadorMovil.setAttribute('hidden', '');
            botonBuscar.setAttribute('aria-expanded', 'false');
          } else {
            buscadorMovil.removeAttribute('hidden');
            botonBuscar.setAttribute('aria-expanded', 'true');
            var campo = buscadorMovil.querySelector('input[type="search"]');
            if (campo) campo.focus();
          }
          medir();
        });
      }
      var botonesPestana = raiz.querySelectorAll('[data-lu-pestana]');
      function activarPestana(indice) {
        botonesPestana.forEach(function (boton) {
          var activa = boton.dataset.luPestana === String(indice);
          boton.classList.toggle('lu-cabecera__pestana--activa', activa);
          boton.setAttribute('aria-expanded', activa ? 'true' : 'false');
        });
        raiz.querySelectorAll('[data-lu-panel-menu]').forEach(function (panel) {
          panel.classList.toggle('lu-cabecera__menu-contenedor--oculto', panel.dataset.luPanelMenu !== String(indice));
        });
        raiz.querySelectorAll('[data-lu-lista-cajon]').forEach(function (lista) {
          lista.classList.toggle('lu-cabecera__panel-lista--oculta', lista.dataset.luListaCajon !== String(indice));
        });
        raiz.querySelectorAll('[data-lu-pestana-enlace]').forEach(function (enlace) {
          enlace.classList.remove('lu-cabecera__pestana--activa');
        });
        raiz.querySelectorAll('[data-lu-franja-menu]').forEach(function (franja) {
          franja.classList.remove('lu-cabecera__menu--sin-desplegable');
        });
        medir();
      }
      var rutaActual = window.location.pathname.replace(/\/+$/, '').toLowerCase();
      raiz.querySelectorAll('[data-lu-pestana-enlace]').forEach(function (enlace) {
        var rutaEnlace = (enlace.pathname || '').replace(/\/+$/, '').toLowerCase();
        if (!rutaEnlace || rutaEnlace === '' || rutaActual.indexOf(rutaEnlace) !== 0) return;
        botonesPestana.forEach(function (boton) {
          boton.classList.remove('lu-cabecera__pestana--activa');
          boton.setAttribute('aria-expanded', 'false');
        });
        raiz.querySelectorAll('[data-lu-pestana-enlace]').forEach(function (otro) {
          otro.classList.toggle('lu-cabecera__pestana--activa', otro.pathname === enlace.pathname);
        });
        raiz.querySelectorAll('[data-lu-panel-menu]').forEach(function (panel) {
          panel.classList.add('lu-cabecera__menu-contenedor--oculto');
        });
        raiz.querySelectorAll('[data-lu-lista-cajon]').forEach(function (lista) {
          lista.classList.add('lu-cabecera__panel-lista--oculta');
        });
        raiz.querySelectorAll('[data-lu-franja-menu]').forEach(function (franja) {
          franja.classList.add('lu-cabecera__menu--sin-desplegable');
        });
      });
      botonesPestana.forEach(function (boton) {
        boton.addEventListener('click', function (evento) {
          evento.preventDefault();
          activarPestana(boton.dataset.luPestana);
        });
      });
      raiz.addEventListener('shopify:block:select', function (evento) {
        var objetivo = evento.target.closest('[data-lu-pestana]');
        if (objetivo) activarPestana(objetivo.dataset.luPestana);
      });
      function medir() {
        var envoltorio = raiz.closest('.shopify-section') || raiz;
        document.documentElement.style.setProperty('--header-height', envoltorio.offsetHeight + 'px');
      }
      medir();
      window.addEventListener('resize', medir);
    }
    function todos() {
      document.querySelectorAll('[data-lu-cabecera]').forEach(iniciar);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', todos);
    } else {
      todos();
    }
    document.addEventListener('shopify:section:load', todos);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunara-carrusel-portada"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(raiz) {
      if (raiz.dataset.luListo) return;
      raiz.dataset.luListo = '1';
      var pista = raiz.querySelector('.lu-carrusel__pista');
      var diapositivas = raiz.querySelectorAll('.lu-carrusel__diapositiva');
      var puntos = raiz.querySelectorAll('[data-lu-punto]');
      var total = diapositivas.length;
      if (!pista || total < 2) return;
      var actual = 0;
      var pausa = false;
      var temporizador = null;
      function ir(indice) {
        actual = (indice + total) % total;
        pista.style.transform = 'translateX(' + (-actual * 100) + '%)';
        diapositivas.forEach(function (d, i) {
          d.classList.toggle('lu-carrusel__diapositiva--activa', i === actual);
          d.setAttribute('aria-hidden', i === actual ? 'false' : 'true');
          d.querySelectorAll('a, button').forEach(function (el) {
            if (!el.classList.contains('lu-carrusel__enlace-completo')) el.tabIndex = i === actual ? 0 : -1;
          });
        });
        puntos.forEach(function (p, i) {
          p.classList.toggle('lu-carrusel__punto--activo', i === actual);
        });
      }
      function arrancar() {
        if (raiz.dataset.auto !== 'true') return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        clearInterval(temporizador);
        temporizador = setInterval(function () {
          if (!raiz.isConnected) { clearInterval(temporizador); return; }
          if (!pausa && !document.hidden) ir(actual + 1);
        }, parseInt(raiz.dataset.velocidad, 10) || 6000);
      }
      var anterior = raiz.querySelector('[data-lu-anterior]');
      var siguiente = raiz.querySelector('[data-lu-siguiente]');
      if (anterior) anterior.addEventListener('click', function () { ir(actual - 1); arrancar(); });
      if (siguiente) siguiente.addEventListener('click', function () { ir(actual + 1); arrancar(); });
      puntos.forEach(function (p) {
        p.addEventListener('click', function () { ir(parseInt(p.dataset.luPunto, 10)); arrancar(); });
      });
      raiz.addEventListener('mouseenter', function () { pausa = true; });
      raiz.addEventListener('mouseleave', function () { pausa = false; });
      raiz.addEventListener('focusin', function () { pausa = true; });
      raiz.addEventListener('focusout', function () { pausa = false; });
      var inicioX = null;
      var inicioY = null;
      raiz.addEventListener('touchstart', function (e) {
        inicioX = e.touches[0].clientX;
        inicioY = e.touches[0].clientY;
      }, { passive: true });
      raiz.addEventListener('touchend', function (e) {
        if (inicioX === null) return;
        var dx = e.changedTouches[0].clientX - inicioX;
        var dy = e.changedTouches[0].clientY - inicioY;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
          ir(dx < 0 ? actual + 1 : actual - 1);
          arrancar();
        }
        inicioX = null;
      });
      raiz.addEventListener('shopify:block:select', function (e) {
        var d = e.target.closest('.lu-carrusel__diapositiva');
        if (!d) return;
        pausa = true;
        ir(parseInt(d.dataset.indice, 10) || 0);
      });
      raiz.addEventListener('shopify:block:deselect', function () { pausa = false; });
      ir(0);
      arrancar();
    }
    function todos() {
      document.querySelectorAll('[data-lu-carrusel]').forEach(iniciar);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', todos);
    } else {
      todos();
    }
    document.addEventListener('shopify:section:load', todos);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunara-coleccion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(raiz) {
      if (raiz.dataset.luListo) return;
      raiz.dataset.luListo = '1';
      var boton = raiz.querySelector('[data-lu-abrir-filtros]');
      var movil = window.matchMedia('(max-width: 989px)');
      function fijar(abierto) {
        raiz.classList.toggle('lu-coleccion--filtros-abiertos', abierto);
        if (boton) boton.setAttribute('aria-expanded', abierto ? 'true' : 'false');
        document.documentElement.style.overflow = abierto && movil.matches ? 'hidden' : '';
      }
      if (boton) {
        boton.addEventListener('click', function () {
          fijar(!raiz.classList.contains('lu-coleccion--filtros-abiertos'));
        });
      }
      raiz.querySelectorAll('[data-lu-cerrar-filtros]').forEach(function (el) {
        el.addEventListener('click', function () { fijar(false); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && raiz.classList.contains('lu-coleccion--filtros-abiertos') && movil.matches) fijar(false);
      });
      if (movil.matches && raiz.classList.contains('lu-coleccion--filtros-abiertos')) fijar(false);
      raiz.querySelectorAll('[data-lu-autoenvio]').forEach(function (campo) {
        campo.addEventListener('change', function () {
          if (campo.form) campo.form.submit();
        });
      });
      raiz.querySelectorAll('[data-lu-orden]').forEach(function (caja) {
        var desplegar = caja.querySelector('[data-lu-orden-boton]');
        var lista = caja.querySelector('[role="listbox"]');
        var formulario = caja.closest('form');
        var campo = formulario ? formulario.querySelector('[data-lu-orden-valor]') : null;
        if (!desplegar || !lista) return;
        var opciones = Array.prototype.slice.call(lista.querySelectorAll('[data-lu-orden-opcion]'));
        function mostrar(abierta) {
          lista.hidden = !abierta;
          desplegar.setAttribute('aria-expanded', abierta ? 'true' : 'false');
          if (abierta) {
            var activa = lista.querySelector('[aria-selected="true"]') || opciones[0];
            if (activa) activa.focus();
          }
        }
        desplegar.addEventListener('click', function () { mostrar(lista.hidden); });
        lista.addEventListener('click', function (e) {
          var opcion = e.target.closest('[data-lu-orden-opcion]');
          if (!opcion) return;
          mostrar(false);
          if (!campo || !formulario || campo.value === opcion.dataset.luOrdenOpcion) return;
          campo.value = opcion.dataset.luOrdenOpcion;
          formulario.submit();
        });
        lista.addEventListener('keydown', function (e) {
          var indice = opciones.indexOf(document.activeElement);
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            opciones[Math.min(opciones.length - 1, indice + 1)].focus();
          } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            opciones[Math.max(0, indice - 1)].focus();
          } else if (e.key === 'Escape') {
            mostrar(false);
            desplegar.focus();
          }
        });
        document.addEventListener('click', function (e) {
          if (!lista.hidden && !caja.contains(e.target)) mostrar(false);
        });
      });
      raiz.querySelectorAll('[data-lu-formulario-filtros]').forEach(function (formulario) {
        formulario.addEventListener('submit', function () {
          formulario.querySelectorAll('input[type="number"]').forEach(function (n) {
            if (n.value === '') n.disabled = true;
          });
        });
      });
      raiz.querySelectorAll('[data-lu-imagen]').forEach(function (muestra) {
        muestra.addEventListener('mouseenter', function () {
          var tarjeta = muestra.closest('.lu-coleccion__tarjeta');
          var imagen = tarjeta ? tarjeta.querySelector('.lu-coleccion__imagen--principal') : null;
          if (!imagen) return;
          imagen.removeAttribute('srcset');
          imagen.src = muestra.dataset.luImagen;
          tarjeta.classList.add('lu-coleccion__tarjeta--color');
          tarjeta.querySelectorAll('[data-lu-enlace-tarjeta]').forEach(function (enlace) {
            enlace.setAttribute('href', muestra.getAttribute('href'));
          });
        });
      });
    }
    function todos() {
      document.querySelectorAll('[data-lu-coleccion]').forEach(iniciar);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', todos);
    } else {
      todos();
    }
    document.addEventListener('shopify:section:load', todos);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunara-pie"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(raiz) {
      if (raiz.dataset.luListo) return;
      raiz.dataset.luListo = '1';
      raiz.querySelectorAll('[data-lu-autoenvio]').forEach(function (selector) {
        selector.addEventListener('change', function () { selector.form.submit(); });
      });
      var consulta = window.matchMedia('(max-width: 749px)');
      var plegables = raiz.querySelectorAll('[data-lu-plegable]');
      function ajustar() {
        plegables.forEach(function (p) {
          if (consulta.matches) {
            p.removeAttribute('open');
          } else {
            p.setAttribute('open', '');
          }
        });
      }
      ajustar();
      if (consulta.addEventListener) consulta.addEventListener('change', ajustar);
    }
    function todos() {
      document.querySelectorAll('.lu-pie').forEach(iniciar);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', todos);
    } else {
      todos();
    }
    document.addEventListener('shopify:section:load', todos);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunara-producto"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function abrirDialogo(dialogo) {
      if (!dialogo) return;
      if (typeof dialogo.showModal === 'function') {
        dialogo.showModal();
      } else {
        dialogo.setAttribute('open', '');
      }
      document.documentElement.style.overflow = 'hidden';
    }

    function cerrarDialogo(dialogo) {
      if (!dialogo) return;
      if (typeof dialogo.close === 'function') {
        dialogo.close();
      } else {
        dialogo.removeAttribute('open');
      }
      document.documentElement.style.overflow = '';
    }

    function convertirMedida(texto) {
      return texto.replace(/\d+(?:[.,]\d+)?/g, function (numero) {
        var valor = parseFloat(numero.replace(',', '.')) / 2.54;
        return (Math.round(valor * 10) / 10).toString().replace('.', ',');
      });
    }

    function iniciar(raiz) {
      if (!raiz || raiz.dataset.luListo === '1') return;
      raiz.dataset.luListo = '1';

      var datos = raiz.querySelector('[data-lu-variantes]');
      var variantes = [];
      try {
        variantes = datos ? JSON.parse(datos.textContent) : [];
      } catch (error) {
        variantes = [];
      }

      var pista = raiz.querySelector('[data-lu-pista]');
      var diapositivas = pista ? Array.prototype.slice.call(pista.children) : [];
      var miniaturas = Array.prototype.slice.call(raiz.querySelectorAll('[data-lu-miniatura]'));
      var botonAnterior = raiz.querySelector('[data-lu-anterior]');
      var botonSiguiente = raiz.querySelector('[data-lu-siguiente]');
      var actual = 0;

      function marcar(indice) {
        actual = indice;
        miniaturas.forEach(function (miniatura, i) {
          var activa = i === indice;
          miniatura.classList.toggle('lu-producto__miniatura--activa', activa);
          miniatura.setAttribute('aria-current', activa ? 'true' : 'false');
          if (activa) {
            var lista = miniatura.closest('ul');
            var elemento = miniatura.parentNode;
            if (lista && lista.scrollWidth > lista.clientWidth) {
              lista.scrollTo({ left: elemento.offsetLeft - lista.clientWidth / 2 + elemento.clientWidth / 2, behavior: 'smooth' });
            }
          }
        });
        if (botonAnterior) botonAnterior.disabled = indice <= 0;
        if (botonSiguiente) botonSiguiente.disabled = indice >= diapositivas.length - 1;
        diapositivas.forEach(function (diapositiva, i) {
          if (i === indice) return;
          var video = diapositiva.querySelector('video');
          if (video && !video.paused) video.pause();
        });
      }

      function irA(indice, suave) {
        if (!pista || !diapositivas.length) return;
        indice = Math.max(0, Math.min(diapositivas.length - 1, indice));
        pista.scrollTo({ left: indice * pista.clientWidth, behavior: suave === false ? 'auto' : 'smooth' });
        marcar(indice);
      }

      if (pista) {
        var espera;
        pista.addEventListener('scroll', function () {
          clearTimeout(espera);
          espera = setTimeout(function () {
            var indice = Math.round(pista.scrollLeft / Math.max(pista.clientWidth, 1));
            if (indice !== actual) marcar(indice);
          }, 80);
        }, { passive: true });
      }
      if (botonAnterior) botonAnterior.addEventListener('click', function () { irA(actual - 1); });
      if (botonSiguiente) botonSiguiente.addEventListener('click', function () { irA(actual + 1); });
      miniaturas.forEach(function (miniatura) {
        miniatura.addEventListener('click', function () {
          irA(parseInt(miniatura.dataset.luMiniatura, 10));
        });
      });

      var ampliacion = raiz.querySelector('[data-lu-ampliacion]');
      var imagenAmpliada = raiz.querySelector('[data-lu-ampliacion-imagen]');
      if (ampliacion && imagenAmpliada) {
        raiz.querySelectorAll('[data-lu-ampliar]').forEach(function (boton) {
          boton.addEventListener('click', function () {
            imagenAmpliada.src = boton.dataset.luAmpliar;
            imagenAmpliada.alt = boton.dataset.luAlt || '';
            abrirDialogo(ampliacion);
          });
        });
        imagenAmpliada.addEventListener('click', function () { cerrarDialogo(ampliacion); });
      }

      var guia = raiz.querySelector('[data-lu-guia]');
      raiz.querySelectorAll('[data-lu-abrir-guia]').forEach(function (boton) {
        boton.addEventListener('click', function () { abrirDialogo(guia); });
      });

      raiz.querySelectorAll('dialog').forEach(function (dialogo) {
        dialogo.addEventListener('click', function (evento) {
          if (evento.target === dialogo || evento.target.closest('[data-lu-cerrar]')) cerrarDialogo(dialogo);
        });
        dialogo.addEventListener('close', function () {
          document.documentElement.style.overflow = '';
        });
      });

      raiz.querySelectorAll('[data-lu-tabla]').forEach(function (tabla) {
        tabla.addEventListener('click', function (evento) {
          var boton = evento.target.closest('[data-lu-unidad]');
          if (!boton) return;
          var pulgadas = boton.dataset.luUnidad === 'in';
          tabla.querySelectorAll('[data-lu-unidad]').forEach(function (otro) {
            var activo = otro === boton;
            otro.classList.toggle('lu-producto__unidad--activa', activo);
            otro.setAttribute('aria-pressed', activo ? 'true' : 'false');
          });
          tabla.querySelectorAll('[data-lu-medida]').forEach(function (celda) {
            var original = celda.dataset.luMedida;
            celda.textContent = pulgadas ? convertirMedida(original) : original;
          });
        });
      });

      raiz.querySelectorAll('[data-lu-cantidad]').forEach(function (caja) {
        var campo = caja.querySelector('input');
        caja.addEventListener('click', function (evento) {
          var boton = evento.target.closest('[data-lu-paso]');
          if (!boton || !campo) return;
          var valor = (parseInt(campo.value, 10) || 1) + parseInt(boton.dataset.luPaso, 10);
          campo.value = Math.max(1, valor);
        });
        if (campo) {
          campo.addEventListener('change', function () {
            campo.value = Math.max(1, parseInt(campo.value, 10) || 1);
          });
        }
      });

      var campoId = raiz.querySelector('[data-lu-id]');
      var botonAnadir = raiz.querySelector('[data-lu-anadir]');
      var textoAnadir = raiz.querySelector('[data-lu-anadir-texto]');
      var grupos = Array.prototype.slice.call(raiz.querySelectorAll('[data-lu-opcion]'));
      var inicial = null;
      variantes.forEach(function (v) {
        if (campoId && String(v.id) === campoId.value) inicial = v;
      });
      if (!inicial) inicial = variantes[0];
      var seleccion = inicial ? inicial.opciones.slice() : [];

      function buscar(opciones) {
        for (var i = 0; i < variantes.length; i++) {
          var coincide = variantes[i].opciones.every(function (valor, posicion) {
            return valor === opciones[posicion];
          });
          if (coincide) return variantes[i];
        }
        return null;
      }

      function aplicar(variante) {
        grupos.forEach(function (grupo) {
          var posicion = parseInt(grupo.dataset.luOpcion, 10);
          grupo.querySelectorAll('[data-lu-valor]').forEach(function (boton) {
            var activo = boton.dataset.luValor === seleccion[posicion];
            boton.classList.toggle('lu-producto__valor--activo', activo);
            boton.setAttribute('aria-pressed', activo ? 'true' : 'false');
            var prueba = seleccion.slice();
            prueba[posicion] = boton.dataset.luValor;
            var candidata = buscar(prueba);
            boton.classList.toggle('lu-producto__valor--agotado', !candidata || !candidata.disponible);
          });
          var elegido = grupo.querySelector('[data-lu-valor-elegido]');
          if (elegido) elegido.textContent = seleccion[posicion] || '';
        });

        if (!variante) {
          if (botonAnadir) {
            botonAnadir.disabled = true;
            if (textoAnadir) textoAnadir.textContent = botonAnadir.dataset.luTextoNoDisponible;
          }
          raiz.querySelectorAll('[data-lu-pagar]').forEach(function (metodo) {
            metodo.disabled = true;
          });
          return;
        }

        if (campoId) campoId.value = variante.id;

        raiz.querySelectorAll('[data-lu-precio-actual]').forEach(function (elemento) {
          elemento.textContent = variante.precio;
          elemento.classList.toggle('lu-producto__precio-actual--oferta', !!variante.anterior);
        });
        raiz.querySelectorAll('[data-lu-precio-anterior]').forEach(function (elemento) {
          elemento.textContent = variante.anterior || '';
          elemento.hidden = !variante.anterior;
        });
        raiz.querySelectorAll('[data-lu-ahorro]').forEach(function (elemento) {
          elemento.textContent = '-' + variante.ahorro + '%';
          elemento.hidden = !variante.anterior;
        });
        raiz.querySelectorAll('[data-lu-sku-caja]').forEach(function (elemento) {
          var sku = elemento.querySelector('[data-lu-sku]');
          if (sku) sku.textContent = variante.sku || '';
          elemento.hidden = !variante.sku;
        });

        raiz.querySelectorAll('[data-lu-pagar]').forEach(function (metodo) {
          metodo.disabled = !variante.disponible;
        });

        if (botonAnadir) {
          botonAnadir.disabled = !variante.disponible;
          if (textoAnadir) textoAnadir.textContent = variante.disponible ? botonAnadir.dataset.luTextoDisponible : botonAnadir.dataset.luTextoAgotado;
        }

        if (variante.media) {
          for (var i = 0; i < diapositivas.length; i++) {
            if (diapositivas[i].dataset.luMedia === String(variante.media)) {
              irA(i);
              break;
            }
          }
        }

        if (window.history && window.history.replaceState) {
          var direccion = new URL(window.location.href);
          direccion.searchParams.set('variant', variante.id);
          window.history.replaceState({}, '', direccion.toString());
        }
      }

      grupos.forEach(function (grupo) {
        var posicion = parseInt(grupo.dataset.luOpcion, 10);
        grupo.addEventListener('click', function (evento) {
          var boton = evento.target.closest('[data-lu-valor]');
          if (!boton) return;
          seleccion[posicion] = boton.dataset.luValor;
          var variante = buscar(seleccion);
          if (!variante) {
            var alternativas = variantes.filter(function (v) {
              return v.opciones[posicion] === seleccion[posicion];
            });
            var disponibles = alternativas.filter(function (v) { return v.disponible; });
            variante = disponibles[0] || alternativas[0] || null;
            if (variante) seleccion = variante.opciones.slice();
          }
          aplicar(variante);
        });
      });

      var formulario = campoId ? campoId.form : null;
      var error = raiz.querySelector('[data-lu-error]');
      if (formulario && botonAnadir) {
        formulario.addEventListener('submit', function (evento) {
          evento.preventDefault();
          if (botonAnadir.disabled || botonAnadir.getAttribute('aria-busy') === 'true') return;
          var cajon = document.querySelector('cart-drawer');
          var envio = new FormData(formulario);
          if (cajon && typeof cajon.getSectionsToRender === 'function') {
            envio.append('sections', cajon.getSectionsToRender().map(function (seccion) { return seccion.id; }));
            envio.append('sections_url', window.location.pathname);
          }
          if (error) error.hidden = true;
          botonAnadir.setAttribute('aria-busy', 'true');
          fetch(raiz.dataset.luUrlAnadir, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
            body: envio
          })
            .then(function (respuesta) { return respuesta.json(); })
            .then(function (respuesta) {
              if (respuesta.status) {
                if (error) {
                  error.textContent = respuesta.description || respuesta.message || raiz.dataset.luTextoError;
                  error.hidden = false;
                }
                return;
              }
              if (cajon && typeof cajon.renderContents === 'function' && respuesta.sections) {
                cajon.classList.remove('is-empty');
                cajon.renderContents(respuesta);
              } else {
                window.location.href = raiz.dataset.luUrlCarrito;
              }
              if (typeof window.publish === 'function' && typeof window.PUB_SUB_EVENTS !== 'undefined') {
                window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'lunara-producto', productVariantId: envio.get('id'), cartData: respuesta });
              }
            })
            .catch(function () {
              if (error) {
                error.textContent = raiz.dataset.luTextoError;
                error.hidden = false;
              }
            })
            .finally(function () {
              botonAnadir.removeAttribute('aria-busy');
            });
        });
      }

      if (formulario) {
        raiz.querySelectorAll('[data-lu-pagar]').forEach(function (metodo) {
          metodo.addEventListener('click', function () {
            if (metodo.disabled || metodo.getAttribute('aria-busy') === 'true') return;
            if (error) error.hidden = true;
            metodo.setAttribute('aria-busy', 'true');
            fetch(raiz.dataset.luUrlAnadir, {
              method: 'POST',
              headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
              body: new FormData(formulario)
            })
              .then(function (respuesta) { return respuesta.json(); })
              .then(function (respuesta) {
                if (respuesta.status) {
                  if (error) {
                    error.textContent = respuesta.description || respuesta.message || raiz.dataset.luTextoError;
                    error.hidden = false;
                  }
                  metodo.removeAttribute('aria-busy');
                  return;
                }
                window.location.href = raiz.dataset.luUrlPago;
              })
              .catch(function () {
                if (error) {
                  error.textContent = raiz.dataset.luTextoError;
                  error.hidden = false;
                }
                metodo.removeAttribute('aria-busy');
              });
          });
        });
      }

      if (inicial && inicial.media && raiz.dataset.luVarianteUrl === '1') {
        for (var j = 0; j < diapositivas.length; j++) {
          if (diapositivas[j].dataset.luMedia === String(inicial.media) && j > 0) {
            irA(j, false);
            break;
          }
        }
      }
    }

    function iniciarTodas(contexto) {
      (contexto || document).querySelectorAll('[data-lu-producto]').forEach(iniciar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { iniciarTodas(); });
    } else {
      iniciarTodas();
    }
    document.addEventListener('shopify:section:load', function (evento) { iniciarTodas(evento.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunara-productos-pestanas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(raiz) {
      if (raiz.dataset.luListo) return;
      raiz.dataset.luListo = '1';
      var titulos = raiz.querySelectorAll('[data-lu-pestana]');
      var paneles = raiz.querySelectorAll('[data-lu-panel]');
      var flechas = raiz.querySelectorAll('[data-lu-mover]');
      function panelActivo() {
        return raiz.querySelector('.lu-pestanas__panel--activo');
      }
      function pistaActiva() {
        var panel = panelActivo();
        return panel ? panel.querySelector('.lu-pestanas__pista') : null;
      }
      function actualizarFlechas() {
        var pista = pistaActiva();
        if (!pista) return;
        var max = pista.scrollWidth - pista.clientWidth - 2;
        flechas.forEach(function (f) {
          var dir = parseInt(f.dataset.luMover, 10);
          f.disabled = dir < 0 ? pista.scrollLeft <= 2 : pista.scrollLeft >= max;
        });
      }
      function activar(indice) {
        titulos.forEach(function (t, i) {
          var activo = i === indice;
          t.classList.toggle('lu-pestanas__titulo--activo', activo);
          t.setAttribute('aria-selected', activo ? 'true' : 'false');
          t.tabIndex = activo ? 0 : -1;
        });
        paneles.forEach(function (p, i) {
          p.classList.toggle('lu-pestanas__panel--activo', i === indice);
        });
        var pista = pistaActiva();
        if (pista) pista.scrollLeft = 0;
        actualizarFlechas();
      }
      titulos.forEach(function (t, i) {
        t.addEventListener('click', function () { activar(i); });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var siguiente = (i + (e.key === 'ArrowRight' ? 1 : -1) + titulos.length) % titulos.length;
          activar(siguiente);
          titulos[siguiente].focus();
        });
      });
      flechas.forEach(function (f) {
        f.addEventListener('click', function () {
          var pista = pistaActiva();
          if (!pista) return;
          var tarjeta = pista.querySelector('.lu-pestanas__tarjeta');
          var paso = tarjeta ? tarjeta.getBoundingClientRect().width + parseFloat(getComputedStyle(pista).columnGap || 0) : pista.clientWidth;
          pista.scrollBy({ left: paso * parseInt(f.dataset.luMover, 10), behavior: 'smooth' });
        });
      });
      paneles.forEach(function (p) {
        var pista = p.querySelector('.lu-pestanas__pista');
        if (pista) pista.addEventListener('scroll', actualizarFlechas, { passive: true });
      });
      raiz.querySelectorAll('[data-lu-imagen]').forEach(function (muestra) {
        muestra.addEventListener('mouseenter', function () {
          var tarjeta = muestra.closest('.lu-pestanas__tarjeta');
          var imagen = tarjeta ? tarjeta.querySelector('.lu-pestanas__imagen--principal') : null;
          if (!imagen) return;
          if (!imagen.dataset.luOriginal) {
            imagen.dataset.luOriginal = imagen.currentSrc || imagen.src;
          }
          imagen.removeAttribute('srcset');
          imagen.src = muestra.dataset.luImagen;
        });
      });
      raiz.addEventListener('shopify:block:select', function (e) {
        var columna = e.target.closest('.lu-pestanas__columna');
        if (!columna) return;
        var boton = columna.querySelector('[data-lu-pestana]');
        if (boton) activar(parseInt(boton.dataset.luPestana, 10));
      });
      window.addEventListener('resize', actualizarFlechas);
      actualizarFlechas();
    }
    function todos() {
      document.querySelectorAll('[data-lu-pestanas]').forEach(iniciar);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', todos);
    } else {
      todos();
    }
    document.addEventListener('shopify:section:load', todos);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunara-relacionados"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function usarRespaldo(raiz, contenido) {
      var respaldo = raiz.querySelector('[data-lu-relacionados-respaldo]');
      if (respaldo && contenido && !contenido.children.length) {
        contenido.appendChild(respaldo.content.cloneNode(true));
      }
    }

    function cargar(raiz) {
      if (!raiz || raiz.dataset.luListo === '1') return;
      raiz.dataset.luListo = '1';
      var contenido = raiz.querySelector('[data-lu-relacionados-contenido]');
      if (!contenido) return;
      if (contenido.children.length) return;
      var url = raiz.dataset.luUrl;
      if (!url || url.indexOf('product_id=&') !== -1) {
        usarRespaldo(raiz, contenido);
        return;
      }
      fetch(url)
        .then(function (respuesta) { return respuesta.text(); })
        .then(function (texto) {
          var documento = new DOMParser().parseFromString(texto, 'text/html');
          var nuevo = documento.querySelector('[data-lu-relacionados-contenido]');
          if (nuevo && nuevo.children.length) {
            contenido.innerHTML = nuevo.innerHTML;
          } else {
            usarRespaldo(raiz, contenido);
          }
        })
        .catch(function () {
          usarRespaldo(raiz, contenido);
        });
    }

    function iniciar(contexto) {
      var elementos = (contexto || document).querySelectorAll('[data-lu-relacionados]');
      if (!('IntersectionObserver' in window)) {
        elementos.forEach(cargar);
        return;
      }
      var observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (entrada) {
          if (!entrada.isIntersecting) return;
          observador.unobserve(entrada.target);
          cargar(entrada.target);
        });
      }, { rootMargin: '0px 0px 400px 0px' });
      elementos.forEach(function (elemento) { observador.observe(elemento); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { iniciar(); });
    } else {
      iniciar();
    }
    document.addEventListener('shopify:section:load', function (evento) { iniciar(evento.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunara-resenas-producto"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(raiz) {
      if (!raiz || raiz.dataset.luListo === '1') return;
      raiz.dataset.luListo = '1';
      var boton = raiz.querySelector('[data-lu-ver-mas]');
      if (!boton) return;
      boton.addEventListener('click', function () {
        raiz.querySelectorAll('.lu-resenas-producto__tarjeta--oculta').forEach(function (tarjeta) {
          tarjeta.classList.remove('lu-resenas-producto__tarjeta--oculta');
        });
        boton.parentNode.removeChild(boton);
      });
    }
    function todas(contexto) {
      (contexto || document).querySelectorAll('[data-lu-resenas-producto]').forEach(iniciar);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { todas(); });
    } else {
      todas();
    }
    document.addEventListener('shopify:section:load', function (evento) { todas(evento.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunara-resenas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(raiz) {
      if (raiz.dataset.luListo) return;
      raiz.dataset.luListo = '1';
      var resenas = raiz.querySelectorAll('.lu-resenas__resena');
      var medios = raiz.querySelectorAll('.lu-resenas__medio');
      var total = resenas.length;
      if (total < 2) return;
      var actual = 0;
      var pausa = false;
      var temporizador = null;
      function ir(indice) {
        actual = (indice + total) % total;
        resenas.forEach(function (r, i) { r.classList.toggle('lu-resenas__resena--activa', i === actual); });
        medios.forEach(function (m, i) { m.classList.toggle('lu-resenas__medio--activo', i === actual); });
      }
      function arrancar() {
        clearInterval(temporizador);
        if (raiz.dataset.auto !== 'true') return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        temporizador = setInterval(function () {
          if (!raiz.isConnected) { clearInterval(temporizador); return; }
          if (!pausa && !document.hidden) ir(actual + 1);
        }, parseInt(raiz.dataset.velocidad, 10) || 7000);
      }
      var anterior = raiz.querySelector('[data-lu-anterior]');
      var siguiente = raiz.querySelector('[data-lu-siguiente]');
      if (anterior) anterior.addEventListener('click', function () { ir(actual - 1); arrancar(); });
      if (siguiente) siguiente.addEventListener('click', function () { ir(actual + 1); arrancar(); });
      raiz.addEventListener('mouseenter', function () { pausa = true; });
      raiz.addEventListener('mouseleave', function () { pausa = false; });
      raiz.addEventListener('shopify:block:select', function (e) {
        var r = e.target.closest('.lu-resenas__resena');
        if (!r) return;
        pausa = true;
        ir(parseInt(r.dataset.indice, 10) || 0);
      });
      raiz.addEventListener('shopify:block:deselect', function () { pausa = false; });
      arrancar();
    }
    function todos() {
      document.querySelectorAll('[data-lu-resenas]').forEach(iniciar);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', todos);
    } else {
      todos();
    }
    document.addEventListener('shopify:section:load', todos);
  })();

  } catch(e) { console.error(e); }
})();
})();
